/** User-roles admin strings (own file — en.ts is at the size ratchet). */
export const enUserRoles = {
	title: "Roles",
	button: "User roles",
	modal: {
		create: {
			permissionPlaceholder: "Select Permissions",
			title: "Create role",
		},
		edit: {
			title: "Update role",
		},
	},
	placeholders: {
		codePlaceholder: "Enter",
		namePlaceholder: "Enter name",
	},
};
